<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          {{ selectedCategoryName ? `Add Weekly Rewards - ${selectedCategoryName}` : 'Add Weekly Rewards' }}
        </v-card-title>

        <v-card-text>
          <!-- Category Selection -->
          <v-row>
            <v-col sm="6">
              <v-autocomplete
                v-model="form.category_id"
                :items="valueLists"
                item-text="description"
                item-value="id"
                outlined
                label="Category *"
                prepend-inner-icon="mdi-tag"
                required
                :disabled="!!$route.query.category"
              />
            </v-col>
          </v-row>

          <!-- Weekly Rewards List -->
          <template v-if="form.weekly_rewards.length > 0">
            <v-row
              v-for="(item, pO) in form.weekly_rewards"
              :key="`item${pO}`"
              class="mb-6"
            >
              <!-- <v-col sm="2">
                <v-text-field
                  v-model="item.name"
                  outlined
                  label="Reward Name"
                  prepend-inner-icon="mdi-gift"
                />
              </v-col> -->

              <v-col sm="2" v-if="!item.store_item_id">
                <v-text-field
                  v-model="item.coin"
                  outlined
                  label="Coin Value"
                  type="number"
                  prepend-inner-icon="mdi-bitcoin"
                  @input="onCoinChange(item)"
                />
              </v-col>

              <v-col sm="2" v-if="!item.coin || item.coin === '' || item.coin === 0">
                <v-autocomplete
                  v-model="item.store_item_id"
                  :items="storeItems"
                  item-text="name"
                  item-value="id"
                  outlined
                  label="Store Item"
                  prepend-inner-icon="mdi-package-variant"
                  clearable
                  @change="onStoreItemChange(item)"
                />
              </v-col>

              <v-col sm="2" v-if="!item.coin || item.coin === '' || item.coin === 0">
                <v-text-field
                  v-model="item.expiry_date"
                  outlined
                  label="Expiry Date"
                  type="date"
                  prepend-inner-icon="mdi-calendar-clock"
                  :min="minDate"
                  required
                />
              </v-col>

              <!-- <v-col sm="2">
                <input
                  type="file"
                  :id="`file-${pO}`"
                  :ref="`file-${pO}`"
                  @change="onFileChange($event, pO)"
                  accept="image/*"
                />

                <v-btn
                  x-small
                  class="reset_image my-1"
                  color="red"
                  dark
                  @click="resetImage(pO)"
                >
                  Remove
                </v-btn>

                <div v-if="item.image_file" class="mt-3">
                  <label>Image Preview</label>
                  <br />
                  <img
                    :src="item.image_file"
                    style="height: 80px; width: 80px; object-fit: cover"
                  />
                </div>
              </v-col> -->

              <!-- Delete Button -->
              <v-col sm="2" class="d-flex align-center">
                <v-btn icon small color="error" @click="deleteReward(pO)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <!-- Add Reward Button -->
          <v-row>
            <v-col>
              <v-btn color="green" dark small @click="Add_Empty_Reward">
                <v-icon left>mdi-plus</v-icon> Add Reward
              </v-btn>
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <!-- Save Button -->
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading || !isFormValid"
            @click="save"
          >
            Save Weekly Rewards
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "WeeklyRewardCreatePage",
  data() {
    return {
      form: {
        category_id: "",
        weekly_rewards: [],
      },
      valueLists: [],
      storeItems: [],
      isLoading: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    minDate() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().split("T")[0];
    },
    isFormValid() {
      return this.form.category_id && this.form.weekly_rewards.length > 0;
    },
    selectedCategoryName() {
      if (this.form.category_id && this.valueLists.length > 0) {
        const category = this.valueLists.find(cat => cat.id == this.form.category_id);
        return category ? category.description : null;
      }
      return null;
    },
  },
  mounted() {
    this.getValueLists();
    this.Add_Empty_Reward(); // Add first reward by default

    // Check if category is pre-filled from URL params
    if (this.$route.query.category) {
      this.form.category_id = this.$route.query.category;
    }
  },
  methods: {
    Add_Empty_Reward() {
      this.form.weekly_rewards.push({
        name: "",
        coin: "",
        store_item_id: null,
        expiry_date: "",
        file: null,
        image_file: null,
      });
    },
    deleteReward(index) {
      this.form.weekly_rewards.splice(index, 1);
    },
    async getValueLists() {
      try {
        const response = await axios.get("/masters?context=reward_category");
        this.valueLists = response.data.reward_category || [];
        this.storeItems = response.data.storeItem || [];
      } catch (e) {
        console.error(e);
      }
    },
    async save() {
      if (!this.isFormValid) {
        this.$toast?.error("Please fill in all required fields");
        return;
      }

      // Validate expiry dates for store items
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      for (let i = 0; i < this.form.weekly_rewards.length; i++) {
        const reward = this.form.weekly_rewards[i];
        if (reward.store_item_id && reward.expiry_date) {
          const expiryDate = new Date(reward.expiry_date);
          expiryDate.setHours(0, 0, 0, 0);

          if (expiryDate <= today) {
            this.$toast?.error(`Expiry date for reward ${i + 1} must be after today`);
            return;
          }
        }
      }

      try {
        this.isLoading = true;

        // Create FormData for file uploads
        const formData = new FormData();
        formData.append("category_id", this.form.category_id);

        // Add each reward data
        this.form.weekly_rewards.forEach((reward, index) => {
          formData.append(`weekly_rewards[${index}][name]`, reward.name || "");
          formData.append(`weekly_rewards[${index}][coin]`, reward.coin || "");
          formData.append(
            `weekly_rewards[${index}][store_item_id]`,
            reward.store_item_id || ""
          );
          formData.append(
            `weekly_rewards[${index}][expiry_date]`,
            reward.expiry_date || ""
          );

          if (reward.file) {
            formData.append(
              `weekly_rewards[${index}][image_path]`,
              reward.file
            );
          }
        });

        const response = await axios.post("/weekly_rewards", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.success) {
          this.$toast?.success("Weekly Rewards created successfully!");
          this.$router.push("/weekly-rewards");
        }
      } catch (error) {
        console.error(error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const errors = error.response.data.errors;
          Object.keys(errors).forEach((key) => {
            this.$toast?.error(errors[key][0]);
          });
        } else {
          this.$toast?.error("Failed to create Weekly Rewards");
        }
      } finally {
        this.isLoading = false;
      }
    },
    onFileChange(event, index) {
      const file = event.target.files[0];
      if (file) {
        // Validate file type
        const allowedTypes = [
          "image/jpeg",
          "image/png",
          "image/jpg",
          "image/gif",
        ];
        if (!allowedTypes.includes(file.type)) {
          this.$toast?.error(
            "Please select a valid image file (JPEG, PNG, JPG, GIF)"
          );
          return;
        }

        // Validate file size (2MB)
        if (file.size > 2 * 1024 * 1024) {
          this.$toast?.error("File size must be less than 2MB");
          return;
        }

        this.form.weekly_rewards[index].file = file;
        this.form.weekly_rewards[index].image_file = URL.createObjectURL(file);
      }
    },
    resetImage(index) {
      this.form.weekly_rewards[index].file = null;
      this.form.weekly_rewards[index].image_file = null;
      if (this.$refs[`file-${index}`] && this.$refs[`file-${index}`][0]) {
        this.$refs[`file-${index}`][0].value = null;
      }
    },
    onCoinChange(item) {
      // Clear store_item_id when coin value is entered
      if (item.coin && item.coin !== '' && item.coin !== 0) {
        item.store_item_id = null;
      }
    },
    onStoreItemChange(item) {
      // Clear coin value when store item is selected
      if (item.store_item_id) {
        item.coin = '';
        // Set default expiry date to tomorrow if not already set
        if (!item.expiry_date) {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          item.expiry_date = tomorrow.toISOString().split('T')[0];
        }
      }
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  margin-bottom: 10px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}
.reset_image {
  margin-top: 5px;
}
</style>
